export { default as InitialsCoin } from './initials-coin';
export { default as PhotoCoin } from './photo-coin';
export { default as StateIcon } from './state-icon';
